module.exports = __webpack_public_path__ + "static/media/ICON_HOME_ACTIVE.3924fd5b.svg";